import * as React from "react";
import { useId } from "@react-aria/utils";
import PropTypes from "prop-types";
import classnames from "classnames";
import Styled from "styled-components";
import { styleObjectToString, styleObjectToCSSString } from "../../utils";
import { Text } from "../../Text";
import FieldItem from "../fieldItem";
import withTemplateInput from "../withTemplateInput";
import css from "./input.module.scss";

const parser = (i) => i.replace(/[^\w.-]+/g, "");

const getValue = (e) => {
  const value = e.target.value.trim().replace(/。/g, ".");

  return value;
};

const inputContainerClasses = classnames(css["input-container"], css.numeric);

const Input = Styled(
  ({
    input,
    label,
    name,
    className,
    icon,
    style,
    onChange,
    value,
    inputRef,
    disabled,
    error,
    htmlType,
    fieldClass,
    formatter,
    ...props
  }) => {
    const handleChange = (e) => {
      const val = parser(getValue(e));
      onChange(val);
    };

    const onBlur = (e) => {
      const val = parser(getValue(e));
      if (props.onBlur) props.onBlur(val);
    };

    const onFocus = (e) => {
      const val = parser(getValue(e));
      if (props.onFocus) props.onFocus(val);
    };

    const inputClasses = classnames(css.input, className);
    const attributeId = useId(props.id);

    return (
      <FieldItem
        type={input.title}
        label={label}
        className={fieldClass}
        htmlFor={props.id || attributeId}
      >
        <div className={inputContainerClasses}>
          <input
            id={attributeId}
            {...props}
            name={name || ""}
            type="number"
            className={inputClasses}
            value={value}
            style={style}
            onChange={handleChange}
            onBlur={onBlur}
            onFocus={onFocus}
            placeholder={props.placeholder}
            ref={inputRef}
            disabled={disabled}
          />
          {icon && <div className={css["input-suffix"]}>{icon}</div>}
        </div>
        {error && <Text type={input.error}>{error}</Text>}
      </FieldItem>
    );
  },
)`
  ${({ input: { field, placeholder } }) => {
    const inputStyles = [];
    if (field) {
      inputStyles.push(styleObjectToString(field));
    }
    if (placeholder) {
      inputStyles.push(
        styleObjectToCSSString("::-webkit-input-placeholder", placeholder),
      );
      inputStyles.push(
        styleObjectToCSSString("::-moz-placeholder", placeholder),
      );
      inputStyles.push(
        styleObjectToCSSString(":-ms-input-placeholder", placeholder),
      );
      inputStyles.push(styleObjectToCSSString("::placeholder", placeholder));
    }
    return inputStyles.join();
  }}
`;

Input.propTypes = {
  formatter: PropTypes.func,
  name: PropTypes.string,
  onChange: PropTypes.func,
};

Input.defaultProps = {
  formatter: (i) => i,
};

export default withTemplateInput(Input);
